import React, { ReactElement } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { COLORS, FONT, MaterialSymbol } from '../shared';

export interface ResourceRowProps {
  icon: string;
  label: string;
  onClick?: () => void;
  isLast?: boolean;
}

export const ResourceRow = ({
  icon,
  label,
  onClick,
  isLast = false,
}: ResourceRowProps): ReactElement => (
  <ButtonBase
    onClick={onClick}
    disableRipple
    sx={{
      width: '100%',
      backgroundColor: COLORS.white,
      borderLeft: `1px solid ${COLORS.cardBorder}`,
      borderRight: `1px solid ${COLORS.cardBorder}`,
      borderTop: `1px solid ${COLORS.cardBorder}`,
      borderBottom: isLast ? `1px solid ${COLORS.cardBorder}` : 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      p: '16px',
      textAlign: 'left',
      transition: 'background-color 150ms ease',
      '&:hover': { backgroundColor: COLORS.hoverRow },
      '&:active': { backgroundColor: COLORS.pressedRow },
      '&:focus-visible': {
        outline: `2px solid ${COLORS.bodyDark}`,
        outlineOffset: '-2px',
      },
    }}
  >
    <MaterialSymbol name={icon} size={18} color={COLORS.bodyDark} />
    <Typography
      sx={{
        flex: '1 0 0',
        minWidth: 0,
        fontFamily: FONT,
        fontWeight: 500,
        fontSize: '14px',
        color: COLORS.bodyDark,
      }}
    >
      {label}
    </Typography>
    <MaterialSymbol name="chevron_right" size={18} color={COLORS.bodyDark} />
  </ButtonBase>
);
